<template>
  <div class="col-xs-12 attributesBlock productBgBlock">
    <div class="row">
      <span class="title">{{attributeGroup.attributeGroupName}}:<span class="attr-nm">{{getSelectedText}}</span></span>
      <button
        <button :class="selected === attribute.attributeId ? 'selectedBg' : ''"
        v-for="attribute in attributeGroup.attributes"
        :key="attribute.attributeId"
        :style="btnStyle(attribute.attributeDisplayValue)"
        v-on:click="setSelected(attribute.attributeId)">
        <span><i :class="selected === attribute.attributeId ? 'fa fa-check' : 'fa'"></i></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttributeImageSelector',
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.$emit('attribute-clicked', attributeId)
    },
    btnStyle (attributeDisplayValue) {
      return 'background-image:url(\'/files/product_attributes/' + attributeDisplayValue + '\')'
    }
  }
}
</script>
